import makeFAIcon from "utils/makeFAIcon";

import { faMicrophone, faLaptop, faVideo } from "@fortawesome/free-solid-svg-icons";

export const MicrophoneIcon = makeFAIcon(faMicrophone);
export const LaptopIcon = makeFAIcon(faLaptop);
export const VideoIcon = makeFAIcon(faVideo);
